import { types } from 'mobx-state-tree';

import PaymentModule from '../../../PaymentModule';
import PaymentMethod from './PaymentMethod';

const PaymentMethodGroup = types
  .compose(
    PaymentModule,
    types.model('PaymentMethodGroup', {
      description: types.maybeNull(types.string),
      methods: types.array(PaymentMethod),
      supports_tokenization: types.boolean,
      type: types.identifier,
    })
  )
  .named('PaymentMethodGroup');

export default PaymentMethodGroup;
